import { z } from '@/libs/zod';
import { isValidPhone, parseDigits, validateCPF } from '@/utils';
import { removeDDIFromAutoInsert } from '@/utils/formatters';

export const userLoginSchema = z
  .object({
    document: z
      .string()
      .trim()
      .min(1, 'CPF é obrigatório')
      .regex(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, 'CPF deve ter o formato 000.000.000-00'),
    phone: z
      .string()
      .trim()
      .min(1, 'Telefone é obrigatório')
      .regex(
        /^(\+55\s?)?(\(\d{2}\)\s?|\d{2}\s?)?\d{4,5}-?\d{4}$/,
        'Telefone deve ter o formato (00) 00000-0000',
      ),
  })
  .transform((data) => ({
    ...data,
    phone: removeDDIFromAutoInsert(parseDigits(data.phone)),
  }))
  .superRefine((data, ctx) => {
    const documentError = validateCPF(parseDigits(data.document));
    if (documentError) {
      ctx.addIssue({
        path: ['document'],
        code: z.ZodIssueCode.custom,
        message: documentError,
      });
    }

    const phoneError = isValidPhone(data.phone);
    if (phoneError) {
      ctx.addIssue({
        path: ['phone'],
        code: z.ZodIssueCode.custom,
        message: phoneError,
      });
    }
  });

export type UserLoginFormData = z.infer<typeof userLoginSchema>;
